import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { getServiceRequestDataById, uploadCompImages } from '../../Api/serviceApiMaster';
import Sample14 from "../../Components/Logo";
import { Table } from "react-bootstrap";
import moment from "moment";
import { useAuth } from '../../Context/AuthContext';
import { FaPencilAlt } from "react-icons/fa";
import Modal from "react-bootstrap/Modal";
import Files from "react-files";
import uploadImg from '../../assets/images/uploadfiles.png';
import uploadedFile from '../../assets/images/fileuploaded.png';

const ManagerRequestData = () => {
    const { user } = useAuth();
    const location = useLocation();
    const requestId = location.pathname.split("/")[4];
    const [serviceData, setServiceData] = useState({});
    const [showAddModal, setShowAddModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [beffiles, setBefFiles] = useState({});
    const [aftfiles, setAftFiles] = useState({});

    const [selectedServiceData, setSelectedServiceData] = useState({});

    console.log("Request Id:", requestId)

    console.log(user, 'user')

    const onFilesChange = (files) => {
        console.log(files, 'files')
        setBefFiles(files[0]);
        const allimg = files.map((item) => URL.createObjectURL(item));
    };

    const onFilesChangeAft = (files) => {
        console.log(files, 'files')
        setAftFiles(files[0]);
        const allimg = files.map((item) => URL.createObjectURL(item));
    };

    const onFilesError = (error, file) => {
        console.log("error code " + error.code + ": " + error.message);
    };

    const handleEdit = (item) => {
        console.log("edit cat", item);
        setShowAddModal(true);
        setSelectedServiceData(item)
    };

    const editSubmitHandler = async () => {
        const formData = new FormData()
        formData.append('beforeimage', beffiles);
        formData.append('afterimage', aftfiles);

        const res = await uploadCompImages(formData, selectedServiceData?.requestItemId, user?.userId);
        // return
        // console.log(res, 'res from sdfbdjg')
        if (res.status === 200) {
            toast.success("Allocated Successfully");

            setShowAddModal(false);
            setSelectedServiceData({})
            fetchRequestById();

        }
        // console.log(res, 'res')
    }

    const fetchRequestById = async () => {
        setLoading(true);
        try {
            const response = await getServiceRequestDataById(requestId);
            setServiceData(response);
        } catch (error) {
            toast.error(`Error loading service data: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {

        fetchRequestById();
    }, [requestId]);

    console.log(serviceData, 'serviceData')


    return (
        <>
            <div className="main-content expand">
                <Container fluid className="fields-container">
                    <h2 className="fields-title">Request Service</h2>
                    {loading && (
                        <div className="loading-overlay">
                            <Sample14 />
                        </div>
                    )}

                    <div className="page-headings">
                        <div className="heading-name">
                            <h2 className="list-title">Customer Request List</h2>
                        </div>
                        {/* <div className="heading-options">
                            <button className="file-btn download-btn"
                                onClick={sendMailforRequest}
                            >
                                <MdEmail className='file-icon' />
                            </button>
                        </div> */}

                    </div>

                    {serviceData?.requestItems?.length > 0 ? (
                        <Table bordered hover responsive className="data-table">
                            <thead>
                                <tr>
                                    {/* <th>Ser.</th> */}
                                    <th>Request Item Id</th>
                                    <th>Request Id</th>
                                    <th>Service Data</th>
                                    <th>Type</th>
                                    <th>quantity</th>
                                    <th>serviceHours</th>
                                    <th>Preferred Date</th>
                                    <th>Proposed Date</th>
                                    <th>Allocated Qty</th>
                                    <th> price</th>
                                    <th>amount</th>
                                    <th>cgst</th>
                                    <th>sgst</th>
                                    <th>igst</th>
                                    <th> grandTotal</th>
                                    <th> Before Image</th>
                                    <th> After Image</th>

                                    {/* <th>taxType</th> */}
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {serviceData?.requestItems?.map((budget, index) => (
                                    <tr key={index}>
                                        <td>{budget.requestItemId}</td>
                                        <td>{budget.requestId}</td>
                                        <td>{budget.serviceData}</td>
                                        <td>{budget.serviceType}</td>
                                        <td>{budget.quantity
                                        }</td>
                                        <td>{budget.serviceHours}</td>
                                        <td>{budget.preferredDate} at {budget?.preferredTime}</td>
                                        <td>{budget?.proposedDate} at {budget?.proposedTime}</td>

                                        <td>{budget.allocatedQuantity}</td>
                                        <td>{budget.price}</td>
                                        <td>{budget.amount}</td>
                                        <td>{budget.cgst}</td>
                                        <td>{budget.sgst
                                        }</td>
                                        <td>{budget.igst}</td>
                                        <td>{budget.grandTotal
                                        }</td>

                                        <td>{budget.beforeImage ? (
                                            <a href={budget.beforeImage} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "underline", color: "#007BFF" }}>
                                                Click Here
                                            </a>
                                        ) : " "}</td>
                                        <td>{budget.afterImage ? (
                                            <a href={budget.afterImage} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "underline", color: "#007BFF" }}>
                                                Click Here
                                            </a>
                                        ) : " "}</td>

                                        {/* <td>{budget.taxType}</td> */}
                                        <td>{budget?.serviceStatusName}</td>
                                        <td>

                                            <Button className="edit-link" onClick={() => {
                                                handleEdit(budget);
                                            }}>
                                                <FaPencilAlt className="edit-icon" />
                                               
                                            </Button>
                                            <p className='btn-title'>Complete</p>
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    ) : (
                        <p className="no-data">No Data found.</p>
                    )}
                </Container>
            </div>

            <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
                <div className="modelMain  modal-dialog-centered ">
                    <Modal.Body className="modelBody ">
                        <div className="m-2">
                            <h6>Request Item Id: {selectedServiceData?.requestItemId}</h6>
                            <p>Parent Id : {selectedServiceData?.requestId}</p>
                            <Container>
                                <Row>
                                    <Col md={6}>
                                        {!beffiles?.id && (
                                            <>
                                                <h5>Upload Before Img</h5>
                                                <Files
                                                    className="files-dropzone"
                                                    onChange={onFilesChange}
                                                    onError={onFilesError}
                                                    accepts={[
                                                        ".jpg", ".jpeg", ".png", ".webp"
                                                    ]}
                                                    multiple
                                                    maxFileSize={50000000}
                                                    minFileSize={0}
                                                    clickable
                                                    name="files"
                                                >
                                                    <img src={uploadImg} height="160" width={"100%"} />
                                                </Files>
                                            </>
                                        )}
                                        {beffiles?.id && (
                                            <>
                                                <h5>Before Image</h5>
                                                <Files
                                                    className="files-dropzone"
                                                    onChange={onFilesChange}
                                                    onError={onFilesError}
                                                    accepts={[
                                                        ".jpg", ".jpeg", ".png", ".webp"
                                                    ]}
                                                    multiple
                                                    maxFileSize={50000000}
                                                    minFileSize={0}
                                                    clickable
                                                >
                                                    <img src={uploadedFile} height="200" width={"100%"} />
                                                </Files>
                                            </>
                                        )}
                                    </Col>
                                    <Col md={6}>
                                        {!aftfiles?.id && (
                                            <>
                                                <h5>Upload After Img</h5>
                                                <Files
                                                    className="files-dropzone"
                                                    onChange={onFilesChangeAft}
                                                    onError={onFilesError}
                                                    accepts={[
                                                        ".jpg", ".jpeg", ".png", ".webp"
                                                    ]}
                                                    multiple
                                                    maxFileSize={50000000}
                                                    minFileSize={0}
                                                    clickable
                                                    name="files"
                                                >
                                                    <img src={uploadImg} height="160" width={"100%"} />
                                                </Files>
                                            </>
                                        )}
                                        {aftfiles?.id && (
                                            <>
                                                <h5>After Image</h5>
                                                <Files
                                                    className="files-dropzone"
                                                    onChange={onFilesChangeAft}
                                                    onError={onFilesError}
                                                    accepts={[
                                                        ".jpg", ".jpeg", ".png", ".webp"
                                                    ]}
                                                    multiple
                                                    maxFileSize={50000000}
                                                    minFileSize={0}
                                                    clickable
                                                >
                                                    <img src={uploadedFile} height="200" width={"100%"} />
                                                </Files>
                                            </>
                                        )}
                                    </Col>
                                </Row>
                                <Row>
                                    <div className="modelFooter justify-content-center">
                                        <button
                                            className="mainButton modelBtn bg-warning"
                                            variant="secondary"
                                            onClick={() => {
                                                setShowAddModal(false);
                                            }}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            className="mainButton modelBtn bg-success"
                                            variant="primary"
                                            onClick={editSubmitHandler}
                                        >
                                            Save
                                        </button>
                                    </div>
                                </Row>
                            </Container>
                        </div>

                    </Modal.Body>
                </div >
            </Modal >
        </>
    )
}

export default ManagerRequestData